import React, { Component } from 'react';
import { compose } from 'redux'
import {connect} from 'react-redux'
import enhanceWithClickOutside from 'react-click-outside';
import {auth} from "../actions";


class SignIn extends Component{
  state = {
    email: "",
    password: "",
    recoverCode: '',
    recoverStatus: false,
    firstLogin: false,
    createAccountStatus: false,
    recoverError: 'Ange koden vi har skickat till dig. Om du inte hittar den kolla även i din skräppost',
    codeSent: false,
    codeConfirmed: false,
    newPassword: '',
    confirmPassword: '',
    passwordError: false,
  }

  handleClickOutside(event) {
    this.props.toggleSignIn()
  }

  handleSignIn = (event) => {
    event.preventDefault()
    this.props.login(this.state.email, this.state.password).then(res => {
        this.props.toggleSignIn()
        this.props.toggleSignedInPopup()
      })
  }

  handleNewPassword = (event) => {
    event.preventDefault()
    if (this.state.newPassword === this.state.confirmPassword){
      if (this.state.newPassword.length > 4) {
        this.props.newPassword(this.state.newPassword, this.state.recoverCode).then(res => {
            this.props.toggleSignIn()
          })
      } else {
        this.setState({passwordError: "Lösenordet måste minst vara 5 bokstäver"})
      }
    } else {
      console.log("Not correct")
      this.setState({passwordError: "Lösenorden stämmer inte överens med varandra"})
    }
  }

  handleRecoverCode = (event) => {
    event.preventDefault()
    this.props.codeLogin(this.state.email, this.state.recoverCode).then(res => {
        if (res.status === 200) {
          console.log("Success")
          this.setState({codeConfirmed: true})
        } else {
          res.json().then(data => {
            this.setState({recoverError: data[0]})

          })
        }
      }).catch((err) => {
        err.json().then(data => {
          this.setState({recoverError: data[0]})

        })
      })
  }

  handleRecoverPassword = (event) => {
    event.preventDefault()
    let email = this.state.email
    let headers = { "Content-Type": "application/json",};
    let body = JSON.stringify({email});
    fetch("/api/auth/reset-password", { headers, body, method: "POST", })
      .then(res => {
        if (res.status === 404) {
          console.log("user does not exist")
        } else if (res.status === 204) {
          this.setState({codeSent: true})
          console.log("An email has been sent");
        } else {
          throw res
        }
    })
  }

  signInForm() {
    return(
      <div>
        <h2>Logga In</h2>
        <form>
          {this.props.errors.length > 0 && (
            <ul>
              {this.props.errors.map(error => (
                <li key={error.field}>{error.message}</li>
              ))}
            </ul>
          )}
          <div className="form-section">
            <label htmlFor="email" className="SignIn-label">Email</label>
            <input type="text" name="email" id="email" className="SignIn-input"
              onChange={e => this.setState({email: e.target.value})}
              value={this.state.email} autoComplete="username email">
            </input>
          </div>
          <div className="form-section">
            <label htmlFor="password" className="SignIn-label">Lösenord</label>
            <input type="password" name="password" className="SignIn-input"
              onChange={e => this.setState({password: e.target.value})}
              id="password" value={this.state.password}
              autoComplete="current-password">
            </input>
          </div>
          <button className="SignIn-button" onClick={this.handleSignIn}>Logga in</button>
        </form>
        <button
          className="SignIn-code-button"
          onClick={() => this.setState({recoverStatus:true, codeSent: true, firstLogin:true})}>
          Logga in med kod
        </button>
        <p className="SignIn-recover-button" onClick={() => this.setState({recoverStatus: true})}>
          Har du glömt ditt lösenord?
        </p>
        <p className="SignIn-recover-button" onClick={() => this.setState({createAccountStatus: true})}>
          Skapa Konto
        </p>
      </div>
    )
  }

  createAccountGuide() {
    return(
      <div>
        <h2>Skapa konto</h2>
        <p>När du checkar ut ur kassan så skapas ett konto automatiskt</p>
        <p className="SignIn-recover-button" onClick={() => this.setState({createAccountStatus: false})}>
          Logga in istället
        </p>
      </div>
    )
  }

  recoverPasswordForm() {
    return(
      <div>
        {
          this.state.firstLogin
          ?
          <h2>Logga in med kod</h2>
          :
          <h2>Återställ lösenord</h2>
        }
        {
          this.state.codeSent
          ?
          <form>
            <div className="form-section">
              <p className="form-code-error">{this.state.recoverError}</p>
              {
                this.state.firstLogin
                ?
                <div className="form-section">
                  <label htmlFor="email" className="SignIn-label">Email</label>
                  <input type="text" name="email" id="email" className="SignIn-input"
                    onChange={e => this.setState({email: e.target.value})}
                    value={this.state.email}>
                  </input>
                </div>
                :
                null
              }
              <label htmlFor="recoverCode" className="SignIn-label">Koden</label>
              <input
                type="text"
                name="recoverCode"
                id="recoverCode"
                className="SignIn-input recoverCode"
                onChange={e => this.setState({recoverCode: e.target.value})}
                value={this.state.recoverCode}>
              </input>
            </div>
            <button className="SignIn-button" onClick={this.handleRecoverCode}>Logga in</button>
          </form>
          :
          <form>
            <div className="form-section">
              <label htmlFor="email" className="SignIn-label">Email</label>
              <input type="text" name="email" id="email" className="SignIn-input"
                onChange={e => this.setState({email: e.target.value})}
                value={this.state.email}>
              </input>
            </div>
            <button className="SignIn-button" onClick={this.handleRecoverPassword}>Återställ</button>
          </form>
        }
        <p
          className="SignIn-recover-button"
          onClick={() => this.setState({recoverStatus: false, firstLogin: false, codeSent: false})}>
          Gå tillbaka
        </p>
      </div>
    )
  }

  renderNewPassForm() {
    return(
      <div>
        <h2>Nytt lösenord</h2>
        <p>Ange ett nytt lösenord</p>
        <p>{this.state.passwordError}</p>
        <form>
          <div className="form-section">
            <label htmlFor="password" className="SignIn-label">Lösenord</label>
            <input
              type="password"
              name="password"
              id="password"
              className="SignIn-input"
              onChange={e => this.setState({newPassword: e.target.value})}
              value={this.state.newPassword}>
            </input>
          </div>
          <div className="form-section">
            <label htmlFor="confirmPassword" className="SignIn-label">Bekräfta Lösenord</label>
            <input
              type="password"
              name="confirmPassword"
              id="confirmPassword" className="SignIn-input"
              onChange={e => this.setState({confirmPassword: e.target.value})}
              value={this.state.confirmPassword}>
            </input>
          </div>
          <button className="SignIn-button" onClick={this.handleNewPassword}>Bekräfta</button>
        </form>
      </div>
    )
  }

  render() {
    return(
      <div className="SignIn">
        {
          !this.state.recoverStatus && !this.state.createAccountStatus
          ?
          this.signInForm()
          :
          null
        }
        {
          this.state.recoverStatus && !this.state.codeConfirmed
          ?
          this.recoverPasswordForm()
          :
          null
        }
        {
          this.state.recoverStatus && this.state.codeConfirmed
          ?
          this.renderNewPassForm()
          :
          null
        }
        {
          this.state.createAccountStatus
          ?
          this.createAccountGuide()
          :
          null
        }
      </div>
    )
  }
}

const mapStateToProps = state => {
  let errors = [];
  if (state.auth.errors) {
    errors = Object.keys(state.auth.errors).map(field => {
      return {field, message: state.auth.errors[field]};
    });
  }
  return {
    errors,
    isAuthenticated: state.auth.isAuthenticated
  };
}

const mapDispatchToProps = dispatch => {
  return {
    login: (username, password) => {
      return dispatch(auth.login(username, password));
    },
    codeLogin: (email, recoverCode) => {
      return dispatch(auth.codeLogin(email, recoverCode));
    },
    newPassword: (newpassword, recovercode) => {
      return dispatch(auth.newPassword(newpassword, recovercode));
    }
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  enhanceWithClickOutside
)(SignIn);



// WEBPACK FOOTER //
// ./src/containers/SignIn.jsx